export default {"title":"_6VnSf","date":"WMY-3"};